import {UIGameEndTableView} from './GameEndTableView'
import {PIXI} from '@colonist/pixi'
import {EndGameStateUtils} from '@colonist/game-endgame-types'
import {EndGameData, VictoryPointStateReader} from '@colonist/game-base-types'
import {EndGameState} from '@colonist/game-states'
import {UIGameEndController} from './UIGameEndController'

export class GameEndStatsOverviewView extends UIGameEndTableView {
    private readonly uiGameEndController: UIGameEndController

    constructor(uiGameEndController: UIGameEndController, x: number, y: number, w: number, h: number, container: PIXI.Container, columnWidth: number, rowHeight: number, endGameState: EndGameState) {
        super(x, y, w, h, container, columnWidth, rowHeight)
        this.uiGameEndController = uiGameEndController

        const allUniqueVictoryPointsInPlay = EndGameStateUtils.getAllUniqueVictoryPointsEarnedByAllPlayers(endGameState.players)
        const endGameVictoryPointData: EndGameData[][] = []
        const players = EndGameStateUtils.getPlayersSortedByRank(endGameState.players)
        for(const player of players) {
            const playerEndGameVictoryPointData: EndGameData[] = []

            playerEndGameVictoryPointData.push({amount: VictoryPointStateReader.totalPrivateVictoryPoints(player.victoryPoints), highest: false})

            for(const uniqueVictoryPoint of allUniqueVictoryPointsInPlay) {
                const highestVictoryPointOfType = EndGameStateUtils.highestVictoryPointScoreOfType(uniqueVictoryPoint, endGameState.players)
                const playerAmountOfVictoryPointsOfType = VictoryPointStateReader.totalVictoryPointsOfType(player.victoryPoints, [uniqueVictoryPoint])
                const doesPlayerHaveHighestScore = playerAmountOfVictoryPointsOfType >= highestVictoryPointOfType
                playerEndGameVictoryPointData.push({amount: playerAmountOfVictoryPointsOfType, highest: doesPlayerHaveHighestScore})
            }

            const rankedUserState = this.uiGameEndController.getPlayerRankedState(player.color)
            if(rankedUserState != undefined) {
                const mmrChange = rankedUserState.rankedState.getEndGameData().amount

                const numericalMMRChange = parseFloat(`${mmrChange}`)
                playerEndGameVictoryPointData.push({amount: mmrChange, highest: false, green: numericalMMRChange > 0, red: numericalMMRChange < 0})
            }

            endGameVictoryPointData.push(playerEndGameVictoryPointData)
        }
        this.createPoints(endGameVictoryPointData)
    }
}
